import { Component } from '@angular/core';
import {
    ErrorInterface,
    InsurancePolicyActionService,
    NewModalModule,
    NewModalRef as ModalRef,
    PurchasedProductInterface,
} from 'outshared-lib';
import {
    WucButtonModule,
    WucCardModule,
    WucIconUiModule,
    WucLinkModule,
    WucListModule
} from '@inshared/website-ui-components';
import { NgForOf, NgIf } from '@angular/common';

@Component({
    standalone: true,
    selector: 'ins-insurance-cancel-added-product-modal',
    templateUrl: 'insurance-cancel-added-product.modal.html',
    imports: [
        NewModalModule,
        NgForOf,
        NgIf,
        WucButtonModule,
        WucCardModule,
        WucIconUiModule,
        WucLinkModule,
        WucListModule,
    ]
})
export class InsuranceCancelAddedProductModal {

    public purchasedProduct: PurchasedProductInterface;
    public isDisabled: boolean;
    public errors: ErrorInterface[];

    constructor(
        private insurancePolicyActionService: InsurancePolicyActionService,
        private modalRef: ModalRef<InsuranceCancelAddedProductModal>,
    ) {
        this.isDisabled = false;
        this.errors = [];
    }

    /**
     * When a new product is added without start date
     * the customer is able to cancel the added product.
     */
    public cancelAddedProduct(): void {
        this.insurancePolicyActionService
            .cancelAddedProduct$({
                productId: this.purchasedProduct.productId,
                productSequenceNumber: this.purchasedProduct.productSequenceNumber,
            }).subscribe({
                next: () => this.onCancelAddedProductSuccess(),
                error: (errors) => this.onCancelAddedProductError(errors),
            });

        this.isDisabled = true;
        this.errors = [];
    }

    public onCancelAddedProductSuccess(): void {
        this.isDisabled = false;
        this.close();
    }

    public onCancelAddedProductError(errors: ErrorInterface[]): void {
        this.errors = errors;
        this.isDisabled = false;
    }

    public close(): void {
        this.modalRef.close();
    }
}
